export enum CPSettingsMenuItem {
  PROFILE = 'profile',
  USERS = 'users',
  CONNECTIONS = 'connections'
}
